import React, { useEffect, useState } from "react";
import { AbstractUploadInput } from "./AbstractUploadInput";
import * as Commons from "oc-commons/Commons";

const ImageInfos = ({ src, changeCounter }) => {
  const [loadedImage, setLoadedImage] = useState(null);
  useEffect(() => {
    const i = new Image();
    i.onload = () => setLoadedImage(i);
    i.src = src;
  }, [src]);
  if (loadedImage == null) {
    return null;
  }
  const entries = performance.getEntriesByName(src);
  const iTime = entries[0];
  return (
    <div className="infos">
      {src.substringAfterLast("/")} <br />
      {loadedImage.width} x {loadedImage.height} px,{" "}
      {Commons.humanFileSize(iTime?.["transferSize"])}
    </div>
  );
};

export const ImageInput = ({ property }) => {
  const [changeCounter, setChangeCounter] = useState(Math.random());
  return AbstractUploadInput({
    property,
    accept: "image/*",
    incUpdate: (setUploading, setErrorMessage) => {
      setChangeCounter(changeCounter + 1);
      setUploading(false);
    },
    preview: ({ property, setUploading, setErrorMessage, children }) => {
      return (
        <div className="flex-column flex-grow-1">
          <div
            className="image-preview"
            style={{ backgroundImage: `url("${property.getUriEncoded() + "?" + changeCounter}")` }}
            title={property.get()}
          >
            {children()}
          </div>
          <ImageInfos src={property.getUriEncoded()} changeCounter={changeCounter} />
        </div>
      );
    },
  });
};
